import PropTypes from 'prop-types'
import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import React from 'react'
import FormButtons from '../../components/FormButtons/FormButtons'
import checkCredentials from '../../utils/assets/check-credentials.svg'
import { colors } from '../../utils/theme/styles'
export default function ConfirmModal({ isOpen, onClose, onContinue }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius=" 15px" w="100%">
        <ModalCloseButton mt="4px" alignSelf="center" color={colors.gray[50]} />
        <ModalBody p="23px">
          {' '}
          <VStack>
            <img src={checkCredentials} />
            <Text>¿Desea confirmar la edición de los datos?</Text>
          </VStack>
        </ModalBody>

        <ModalFooter p="32px" h="56px" w="100%">
          <Center h="56px" w="100%">
            <FormButtons onContinue={onContinue} onBack={onClose} />
          </Center>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
}
